export default __webpack_public_path__ + "static/media/AllMine_159x150.98f211b6.png";